type serverSideError = {data: {validationMessages: {paramName: string; message: string}[]}};

export function useAddServerSideFieldErrors() {
    return (setFieldError: (field: string, errorMsg: string) => void, error: {response: serverSideError}) => {
        error?.response?.data?.validationMessages?.map((fieldError: {paramName: string; message: string}) => {
            setFieldError(fieldError.paramName, fieldError.message);
        });
    };
}
